import gql from 'graphql-tag';

export default gql`
  mutation login($user: LoginInput!) {
    login(user: $user) {
      id
      username
      authToken
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/login.mutation.js